/* Rosy Paris — global interactions */
(function () {
  "use strict";

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- mobile menu ---------- */
  var burger = qs("[data-mobile-burger]");
  var mobileMenu = qs("[data-mobile-menu]");
  var scrim = qs("[data-scrim]");
  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove("is-open");
    if (scrim) scrim.classList.remove("is-open");
  }
  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
  }
  if (burger) burger.addEventListener("click", openMobileMenu);
  qsa("[data-mobile-menu-close]").forEach(function (el) { el.addEventListener("click", closeMobileMenu); });
  if (scrim) scrim.addEventListener("click", function () { closeMobileMenu(); closeCartDrawer(); });

  /* ---------- search toggle ---------- */
  var searchToggle = qs("[data-search-toggle]");
  var searchBar = qs("[data-search-bar]");
  if (searchToggle && searchBar) {
    searchToggle.addEventListener("click", function () {
      searchBar.classList.toggle("is-open");
      if (searchBar.classList.contains("is-open")) {
        var input = qs("input[type=text]", searchBar);
        if (input) input.focus();
      }
    });
  }
  qsa("[data-search-close]").forEach(function (el) {
    el.addEventListener("click", function () { if (searchBar) searchBar.classList.remove("is-open"); });
  });

  /* ---------- cart drawer ---------- */
  var cartDrawer = qs("[data-cart-drawer]");
  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove("is-open");
    if (scrim) scrim.classList.remove("is-open");
  }
  qsa("[data-cart-toggle]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      if (cartDrawer && cartDrawer.classList.contains("is-open")) { closeCartDrawer(); } else { openCartDrawer(); }
    });
  });
  qsa("[data-cart-close]").forEach(function (el) { el.addEventListener("click", closeCartDrawer); });

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch("/?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("[data-cart-drawer]");
        if (fresh) {
          cartDrawer.innerHTML = fresh.innerHTML;
        }
        updateCartCount();
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* Add to cart (quick add on cards + main product form) */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches("[data-add-to-cart-form]")) return;
    e.preventDefault();
    var submitBtn = qs("[type=submit]", form);
    if (submitBtn) submitBtn.disabled = true;
    var formData = new FormData(form);
    fetch("/cart/add.js", { method: "POST", body: formData, headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          alert(res.description || "Une erreur est survenue.");
          return;
        }
        var justAdded = qs("[data-just-added]", form);
        if (justAdded) {
          justAdded.classList.add("is-visible");
          setTimeout(function () { justAdded.classList.remove("is-visible"); }, 3000);
        }
        refreshCartDrawer().then(openCartDrawer);
      })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  /* Cart page / drawer quantity & remove (event delegation, works for dynamically refreshed drawer too) */
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-cart-qty-step]");
    if (stepBtn) {
      e.preventDefault();
      var key = stepBtn.getAttribute("data-key");
      var dir = stepBtn.getAttribute("data-cart-qty-step");
      var input = qs('[data-cart-qty-input][data-key="' + key + '"]');
      if (!input) return;
      var val = parseInt(input.value || input.getAttribute("data-value") || "1", 10);
      val = dir === "inc" ? val + 1 : Math.max(0, val - 1);
      changeCartLine(key, val);
      return;
    }
    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      changeCartLine(removeBtn.getAttribute("data-key"), 0);
    }
  });

  function changeCartLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function () {
        if (qs("[data-cart-page]")) {
          window.location.reload();
        } else {
          refreshCartDrawer();
        }
      })
      .catch(function () {});
  }

  /* ---------- product variant picker ---------- */
  qsa("[data-product-form]").forEach(function (root) {
    var variants = JSON.parse(root.getAttribute("data-variants") || "[]");
    /* The price block sits OUTSIDE the <form>, so search the whole product page */
    var pageRoot = root.closest("[data-product-page]") || document;
    var variantIdInput = qs("[data-variant-id]", root);
    var priceEl = qs("[data-product-price]", pageRoot);
    var comparePriceEl = qs("[data-product-compare-price]", pageRoot);
    var addBtn = qs("[data-add-btn]", root);
    var mainImage = qs("[data-product-main-image]", pageRoot);

    function selectedOptions() {
      var opts = [];
      qsa("[data-option-index]", root).forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        var active = qs(".is-active", group);
        opts[idx] = active ? active.getAttribute("data-value") : null;
      });
      return opts;
    }

    function findVariant() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function money(cents) {
      return "€" + (cents / 100).toFixed(2).replace(".", ",");
    }

    function updateOptionLabels() {
      qsa("[data-option-index]", root).forEach(function (group) {
        var active = qs(".is-active", group);
        var labelEl = qs("[data-option-current]", group);
        if (labelEl && active) {
          labelEl.textContent = active.getAttribute("data-value");
        }
      });
    }

    function render() {
      updateOptionLabels();
      var variant = findVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = "";
        } else {
          comparePriceEl.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute("data-label-available") : addBtn.getAttribute("data-label-sold-out");
      }
      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src || variant.featured_image;
      }
    }

    qsa("[data-option-value]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest("[data-option-index]");
        qsa(".is-active", group).forEach(function (a) { a.classList.remove("is-active"); });
        btn.classList.add("is-active");
        render();
      });
    });

    render();
  });

  /* ---------- gallery thumbnails ---------- */
  qsa("[data-gallery]").forEach(function (gallery) {
    var main = qs("[data-product-main-image]", gallery);
    qsa("[data-thumb]", gallery).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        qsa("[data-thumb]", gallery).forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
        var fullSrc = thumb.getAttribute("data-full-src");
        if (main && fullSrc) main.src = fullSrc;
      });
    });
  });

  /* ---------- quantity steppers (product page) ---------- */
  qsa("[data-qty-stepper]").forEach(function (stepper) {
    var input = qs("input", stepper);
    qsa("button", stepper).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var val = parseInt(input.value || "1", 10);
        val = btn.getAttribute("data-step") === "inc" ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });

  /* ---------- collection pills (client-side type filter, progressive enhancement) ---------- */
  qsa("[data-type-pill]").forEach(function (pill) {
    pill.addEventListener("click", function (e) {
      // Native link navigation handles the filtering server-side; nothing else needed.
    });
  });

  /* ---------- wishlist (local, cosmetic) ---------- */
  function wishlistKey() { return "rosyparis_wishlist"; }
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(wishlistKey()) || "{}"); } catch (e) { return {}; }
  }
  function setWishlist(w) {
    try { localStorage.setItem(wishlistKey(), JSON.stringify(w)); } catch (e) {}
  }
  function paintWishlistButtons() {
    var w = getWishlist();
    qsa("[data-wishlist-btn]").forEach(function (btn) {
      var id = btn.getAttribute("data-wishlist-btn");
      btn.classList.toggle("is-active", !!w[id]);
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-btn]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-wishlist-btn");
    var w = getWishlist();
    w[id] = !w[id];
    setWishlist(w);
    paintWishlistButtons();
  });
  paintWishlistButtons();

  updateCartCount();
})();
